<template>
    <div class="card p-3 border-radius-xl bg-white" data-animation="FadeIn">
        <h5 class="font-weight-bolder mb-0">Personalização</h5>
        <p class="mb-0 text-sm">Solicite mais informações sobre a personalização da sua unidade ou formalize
            resumidamente sua proposta</p>
        <div v-if="loading" class="mt-4">
            <div class="d-flex justify-content-center mt-2">
                <p><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
            </div>
        </div>
        <div v-if="!loading && !personalization" class="mt-4">
            <div class="text-center justify-content-center segment-primary-color font-weight-bolder row">
                Personalização Indisponível
            </div>
            <div class="text-center justify-content-center font-weight-bolder row" style="font-size: 15px;">
                A personalização para esta unidade não está disponível.
            </div>
        </div>
        <div v-else-if="!loading && personalization">
            <form role="form" class="text-start" @submit.prevent="formValidation">
                <div class="multisteps-form__content mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-12">
                            <label>Descrição*</label>
                            <textarea v-model="form.message" rows="5" class="form-control"
                                placeholder="Descreva brevemente sua solicitação">Descrição*</textarea>
                        </div>
                    </div>
                    <div class="button-row d-flex mt-2">
                        <button type="submit" class="btn custom-btn bg-segment-primary-color ms-auto mb-0"
                            :disabled="loadingButton">Enviar <i v-if="loadingButton"
                                class="fa fa-spinner fa-pulse fa-fw"></i></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import axios from "axios";
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showToast } from "@/assets/js/toast.js";
import { SALESFORCE_DIVISIONS } from '@/assets/js/constants.js';
import { ref, reactive, computed, onMounted } from "vue";

const store = useStore();
const personalization = ref(0)
const loading = ref(false)
const loadingButton = ref(false)
const contractData = computed(() => store.getters.getCurrentContract);



onMounted(() => {
    customizationAvailable()
});

const form = reactive({
    subject: ref('Personalização'),
    message: ref(''),
    division_id: ref(SALESFORCE_DIVISIONS.PERSONALIZAÇÃO),
    contract_id: ref(parseInt(contractData.value.contrato_id)),
    origin_id: ref(2)
});

const rules = {
    subject: { required }, //255
    message: { required }, //32000
    division_id: { required },
    contract_id: { required },
};

const validate = useVuelidate(rules, form);


const formValidation = () => {
    validate.value.$touch();
    if (validate.value.$invalid) {
        showToast('Campos obrigatórios não preenchidos.', 'error');
        return;
    }
    createOccurrences()
};

const createOccurrences = async () => {

    try {
        loadingButton.value = true;
        const response = await axios.post('/contact/customization', form);
        if (response.data) {
            form.message = ''
            showToast('Solicitação enviada com sucesso!', 'success')
        }
    } catch (error) {
        if (error.response) {
            console.log(error.response.data.message)
            showToast(error.response.data.message, 'error')
        } else {
            console.error('Erro de resposta desconhecido:', error)
            showToast('Erro desconhecido ao processar a resposta', 'error')
        }
    } finally {
        loadingButton.value = false;
    }
}

const customizationAvailable = async () => {

    try {
        loading.value = true
        const response = await axios.get(`/clients/salesforce/customization/${contractData.value.contrato_id}`);
        if (response.data.authorization) {
            personalization.value = response.data.authorization
        }
    } catch (error) {
        if (error.response) {
            console.log(error.response.data.message)
            showToast(error.response.data.message, 'error')
        } else {
            console.error('Erro de resposta desconhecido:', error)
            showToast('Erro desconhecido ao processar a resposta', 'error')
        }
    } finally {
        loading.value = false;
    }
}

</script>
